import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatService } from '@app/+chat/services/chat.service';
import { ChatModalInfo } from '@app/+chat/models/chat-modal-info.model';

@Component({
  selector: 'vc-modal-blockuser',
  templateUrl: './modal-blockuser.component.html',
  styleUrls: ['./modal-blockuser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalBlockuserComponent implements OnInit {
  public isBlocked: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ChatModalInfo,
    public dialogRef: MatDialogRef<ModalBlockuserComponent>,
    private chatService: ChatService
  ) {}

  ngOnInit() {
    this.isBlocked = this.data.receiverIsBlocked;
  }

  close() {
    this.dialogRef.close(this.data.receiverIsBlocked);
  }

  async blockUser() {
    try {
      await this.chatService.banUserFromChannel(this.data.channel, this.data.receiver.id);
      this.data.receiverIsBlocked = true;
      this.dialogRef.close(this.data);
    } catch (_) {}
  }

  async unblockUser() {
    try {
      await this.chatService.unbanUserFromChannel(this.data.channel, this.data.receiver.id);
      this.data.receiverIsBlocked = false;
      this.dialogRef.close(this.data);
    } catch (_) {}
  }
}
